/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const registerUser = /* GraphQL */ `
  mutation RegisterUser($user: RegisterUserInput!, $password: String!) {
    registerUser(user: $user, password: $password) {
      PK
      SK
      firstName
      lastName
      dateOfBirth
      nationOfBirth
      provinceOfBirth
      birthPlace
      nationality
      gender
      fiscalCode
      fiscalCodeConfirm
      country
      province
      city
      address
      houseNumber
      zipCode
      mobileNumberPrefix
      mobileNumber
      phoneNumberPrefix
      phoneNumber
      documentType
      number
      releaseDate
      expirationDate
      releasedBy
      nickname
      email
      securityQuestion
      secretAnswer
      presenterCode
      promoCode
      period
      depositLimit
      confirmDepositLimit
      adultYes
      termsAndConditionYes
      privacyTerms
      newsletterYes
      createdAt
      userStatus
    }
  }
`;
export const changeAddressData = /* GraphQL */ `
  mutation ChangeAddressData(
    $addressData: UserAddressDataInput!
    $password: String!
  ) {
    changeAddressData(addressData: $addressData, password: $password)
  }
`;
export const makeDepositOrder = /* GraphQL */ `
  mutation MakeDepositOrder($input: DepositOrderInput) {
    makeDepositOrder(input: $input) {
      orderId
      amount
      valute
      description
    }
  }
`;
export const generateGameSessionToken = /* GraphQL */ `
  mutation GenerateGameSessionToken($currency: String!, $lang: String!) {
    generateGameSessionToken(currency: $currency, lang: $lang)
  }
`;
export const generateGameSessionTokenTimelessTech = /* GraphQL */ `
  mutation GenerateGameSessionTokenTimelessTech(
    $currency: String!
    $lang: String!
    $gameId: String
    $buyIn: Float
    $category: String!
  ) {
    generateGameSessionTokenTimelessTech(
      currency: $currency
      lang: $lang
      gameId: $gameId
      buyIn: $buyIn
      category: $category
    )
  }
`;
export const generateGameSessionTokenBetradar = /* GraphQL */ `
  mutation GenerateGameSessionTokenBetradar(
    $currency: String!
    $lang: String!
    $gameId: String
    $buyIn: Float
    $category: String!
  ) {
    generateGameSessionTokenBetradar(
      currency: $currency
      lang: $lang
      gameId: $gameId
      buyIn: $buyIn
      category: $category
    )
  }
`;
export const generateGameSessionTokenAtlas = /* GraphQL */ `
  mutation GenerateGameSessionTokenAtlas(
    $staging: Boolean!
    $lang: String!
    $category: String!
    $currency: String!
    $ip: String
  ) {
    generateGameSessionTokenAtlas(
      staging: $staging
      lang: $lang
      category: $category
      currency: $currency
      ip: $ip
    ) {
      clientInternalId
      sessionToken
    }
  }
`;
export const sessionManagement = /* GraphQL */ `
  mutation SessionManagement($session: String!, $oper: String!) {
    sessionManagement(session: $session, oper: $oper) {
      success
      ext
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage($input: MessageInput!, $to: String!) {
    createMessage(input: $input, to: $to) {
      PK
      SK
      messageText
      messageCategory
      createdAt
      author
      messageSubject
    }
  }
`;
export const notifyPlaceBet = /* GraphQL */ `
  mutation NotifyPlaceBet($username: String!) {
    notifyPlaceBet(username: $username) {
      PK
      SK
      accountState
      deposit
      bonus
      withdrawable
      valute
      createdAt
      lastDepositDate
      weekTotal
      monthTotal
      depositLimit
      depositLimitPeriod
      pickedUp
      expenses
      updatedAt
      winnings
    }
  }
`;
export const notifyWinning = /* GraphQL */ `
  mutation NotifyWinning($limit: Int, $dal: AWSTimestamp!, $al: AWSTimestamp!) {
    notifyWinning(limit: $limit, dal: $dal, al: $al) {
      username
      amount
      amountWinning
      valute
    }
  }
`;
export const makeWithdrawal = /* GraphQL */ `
  mutation MakeWithdrawal($amount: Float, $method: String!) {
    makeWithdrawal(amount: $amount, method: $method) {
      PK
      SK
      accountState
      deposit
      bonus
      withdrawable
      valute
      createdAt
      lastDepositDate
      weekTotal
      monthTotal
      depositLimit
      depositLimitPeriod
      pickedUp
      expenses
      updatedAt
      winnings
    }
  }
`;
export const updateGameBookmark = /* GraphQL */ `
  mutation UpdateGameBookmark($section: String, $gameIds: String) {
    updateGameBookmark(section: $section, gameIds: $gameIds) {
      PK
      SK
      gameIds
    }
  }
`;
